import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { LocalStorageService } from '../services/local-storage.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class XFrameOptionsInterceptor implements HttpInterceptor {
  constructor(private readonly lsService: LocalStorageService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.url.includes('https://viacep.com.br')) {
      let request = req.clone({
        headers: req.headers.set('Content-Security-Policy', 'none').set('X-Frame-Options', 'DENY')
      });
      return next.handle(request);
    } else {
      return next.handle(req);
    }
  }
}
